import {useQuery} from '@tanstack/react-query';

import {GetListOutput, GetListParams} from '@shared/api';
import {getRatings} from '../api';
import {QUERY__RATINGS} from '../queryKeys';
import {UserRating} from '../types';

import {QueryOptionsForList} from '@/shared/api';

export const useGetRatings = <SelectedData = GetListOutput<UserRating>>(
  params: GetListParams,
  options?: QueryOptionsForList<UserRating, SelectedData>,
) => {
  return useQuery({
    queryKey: [QUERY__RATINGS, params],
    queryFn: () => getRatings(params),
    ...options,
  });
};
